import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["star", "status"]

  static values = {
    selected: Number,
    hovered: Number,
  }

  connect() {
    this.render()
  }

  preview(event) {
    this.hoveredValue = this.ratingValueFor(event.currentTarget)
    this.render()
  }

  focus(event) {
    this.preview(event)
  }

  blur() {
    this.clearHover()
  }

  clearHover() {
    this.hoveredValue = 0
    this.render()
  }

  select(event) {
    this.selectedValue = this.ratingValueFor(event.currentTarget)
    this.hoveredValue = 0
    this.render()
  }

  keydown(event) {
    const currentValue = this.ratingValueFor(event.currentTarget)
    let nextValue = currentValue

    switch (event.key) {
      case "ArrowRight":
      case "ArrowUp":
        nextValue = Math.min(this.starTargets.length, currentValue + 1)
        break
      case "ArrowLeft":
      case "ArrowDown":
        nextValue = Math.max(1, currentValue - 1)
        break
      case "Home":
        nextValue = 1
        break
      case "End":
        nextValue = this.starTargets.length
        break
      case " ":
      case "Enter":
        event.preventDefault()
        this.select(event)
        return
      default:
        return
    }

    event.preventDefault()
    this.selectedValue = nextValue
    this.hoveredValue = 0
    this.render()
    this.focusValue(nextValue)
  }

  ratingValueFor(star) {
    return Number(star.dataset.ratingValue || 0)
  }

  focusValue(value) {
    const target = this.starTargets.find((star) => this.ratingValueFor(star) === value)

    if (target) {
      target.focus()
    }
  }

  render() {
    const displayValue = this.hoveredValue > 0 ? this.hoveredValue : this.selectedValue
    const activeTabValue = this.selectedValue > 0 ? this.selectedValue : 1

    this.starTargets.forEach((star) => {
      const value = this.ratingValueFor(star)
      let state = "default"

      if (displayValue > 0 && value <= displayValue) {
        state = this.hoveredValue > 0 ? "hovered" : "selected"
      }

      star.dataset.state = state
      star.setAttribute("aria-checked", (value === this.selectedValue).toString())
      star.tabIndex = value === activeTabValue ? 0 : -1
    })

    if (this.hasStatusTarget) {
      this.statusTarget.textContent =
        this.selectedValue > 0
          ? `${this.selectedValue} star${this.selectedValue === 1 ? "" : "s"} selected`
          : "No rating selected"
    }
  }
}
